import styled from '@emotion/styled'

export const StyledTitle = styled('h5')(({theme}) => ({
  fontSize: theme.typography.tabTitle.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.hpAccentBlack,
  margin: 0
}))
